import styled from "styled-components";
import Variables from "../styleVariables";
import { FIXED_BOTTOM_BAR_BUTTON_HEIGHT } from "../../constants/fixedStyleVariables";

export const StyledFixedRowButton = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: ${FIXED_BOTTOM_BAR_BUTTON_HEIGHT}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 32px;
  background-color: ${Variables.colors.white};
  z-index: ${props => (props.zIndex ? props.zIndex : 9999)};
  border-top: 1px solid ${Variables.colors.complementary_400};
  .right-part {
    display: flex;
    & > div {
      margin-left: 16px;
    }
  }
`;
